import { useEffect } from 'react';
import useProductActions from '../hooks/useProductActions';
import { ProductType } from '../interface/interface';
import Products from './Products';

export default function ProductTypes({
  productType,
}: Readonly<{
  productType: ProductType;
}>) {
  const [
    loading,
    dataprops,
    searchProps,
    filterProps,
    sortProps,
    paginationProps,
  ] = useProductActions(productType);

  useEffect(() => {
    const tab = sessionStorage.getItem('selectedProductsTab');

    if (!tab) {
      localStorage.removeItem('productCategroy');
      localStorage.removeItem('productFormulation');
      localStorage.removeItem('productCondition');
    }
    sessionStorage.removeItem('selectedProductsTab');
  }, []);

  return (
    <Products
      dataProps={dataprops}
      loading={loading}
      searchProps={searchProps}
      filterProps={filterProps}
      sortProps={sortProps}
      paginationProps={paginationProps}
      type={productType}
    />
  );
}
